import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import CadastroAluno from './components/CadastroAluno';
import ListaAlunos from './components/ListaAlunos';
import Mensalidades from './components/Mensalidades';
import MensalidadesPagas from './components/MensalidadesPagas';
import RotaProtegida from './components/RotaProtegida';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/home"
          element={
            <RotaProtegida>
              <Home />
            </RotaProtegida>
          }
        />
        <Route
          path="/cadastro"
          element={
            <RotaProtegida>
              <CadastroAluno />
            </RotaProtegida>
          }
        />
        <Route
          path="/editar-aluno/:matricula"
          element={
            <RotaProtegida>
              <CadastroAluno isEditing={true} />
            </RotaProtegida>
          }
        />
        <Route
          path="/lista"
          element={
            <RotaProtegida>
              <ListaAlunos />
            </RotaProtegida>
          }
        />
        <Route
          path="/mensalidades"
          element={
            <RotaProtegida>
              <Mensalidades />
            </RotaProtegida>
          }
        />
        <Route
          path="/mensalidades-pagas"
          element={
            <RotaProtegida>
              <MensalidadesPagas />
            </RotaProtegida>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
